import { Component, OnInit } from '@angular/core';
import { Router, Params } from '@angular/router';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivityService } from '../../common/activity.service';
import { ActivityQuestionOptionFormComponent } from '../activity-question-option-form/activity-question-option-form.component';
import { ActivityQuestionsComponent } from '../activity-questions/activity-questions.component';
import { MdDialog } from '@angular/material';

@Component({
  selector: 'activity-question-options',
  templateUrl: './activity-question-options.component.html',
  styleUrls: ['./activity-question-options.component.css', '../../app.component.css'],
  providers: [ActivityService]
})
export class ActivityQuestionOptionsComponent implements OnInit {

  eventId: any;
  activityId: any;
  activityQuestionId: any;
  activityQuestionOptions: any;
  activityQuestionOptionId: any;
  activityQuestionOption: any;
  spinner: boolean = false;

  constructor(private formBuilder: FormBuilder, private activityService: ActivityService, public dialog: MdDialog){
  }

  ngOnInit() {
  }

  getActivityQuestionOptions(){
   this.spinner = true;
   this.activityService.getActivityQuestionOptions(this.activityQuestionId).subscribe(
    response => {
     this.spinner = false;
     this.activityQuestionOptions = response;
    },
    error => {
     this.spinner = false;
    }
   );
  }

  activityQuestionOptionFormDialog(params) {
    if(params && params.id)
    this.activityQuestionOptionId = params.id;
    else
    this.activityQuestionOptionId = 0;
    let dialogRef = this.dialog.open(ActivityQuestionOptionFormComponent);
    dialogRef.componentInstance.activityQuestionId = this.activityQuestionId;
    dialogRef.componentInstance.activityQuestionOptionId = this.activityQuestionOptionId;
    if(this.activityQuestionOptionId)
    {
     this.activityService.findActivityQuestionOption(this.activityQuestionOptionId).subscribe(response => {
      dialogRef.componentInstance.activityQuestionOption = response[0];
     });
    }
    else
    dialogRef.componentInstance.activityQuestionOption = dialogRef.componentInstance.activityQuestionOptionForm.value;
    dialogRef.componentInstance.onSave.subscribe(() => {
     this.getActivityQuestionOptions();
     dialogRef.close();
    });
  }

  deleteActivityQuestionOption(params){
   if(confirm('Are you sure?'))
   {
    this.spinner = true;
    this.activityService.deleteActivityQuestionOption(params).subscribe(
     response => {
      this.spinner = false;
      if(response.status)
      this.getActivityQuestionOptions();
     },
     error => {
      this.spinner = false;
     }
    );
   }
  }

  activityQuestionsDialog(params) {
    this.activityId = params.id;
    let dialogRef = this.dialog.open(ActivityQuestionsComponent);
    dialogRef.componentInstance.activityId = this.activityId;
    if(params.parentOptionId)
    dialogRef.componentInstance.parentOptionId = params.parentOptionId;
    dialogRef.componentInstance.getActivityQuestions();
  }

}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/admin/activity-question-options/activity-question-options.component.ts